import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import JSZip from "jszip";   // ⬅️ tambahan import JSZip

function Monitoring() {
  const [rows, setRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [ulpFilter, setUlpFilter] = useState("");
  const [apkFilter, setApkFilter] = useState("");
  const [kondisiFilter, setKondisiFilter] = useState("");
  const [fotoFile, setFotoFile] = useState("");
  const [showModal, setShowModal] = useState(false);

  const url =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vTBNQUhkCR9DHNLlwXsIZKy7lO1_2Jt0KxKEU2BHp7LykkgUK9kQQAqIFqJEoVQ0yv10sKgBckXs7vJ/pub?gid=415788090&single=true&output=csv";

  const fetchData = () => {
    fetch(url)
      .then((res) => res.text())
      .then((csvText) => {
        const result = Papa.parse(csvText, { header: true });
        setRows(result.data);
      })
      .catch((err) => {
        console.error("Gagal fetch data:", err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setFotoFile("");
    setShowModal(false);
  }, [searchTerm, ulpFilter, apkFilter, kondisiFilter]);

  const getUniqueValues = (key) => {
    return [...new Set(rows.map((row) => row[key]).filter(Boolean))];
  };

  const filteredRows = rows.filter((row) => {
    const id = row["ID PELANGGAN"]?.toLowerCase() || "";
    const name = row["NAMA"]?.toLowerCase() || "";
    const term = searchTerm.toLowerCase();
    const ulpMatch = ulpFilter ? row["ULP"] === ulpFilter : true;
    const apkMatch = apkFilter ? row["KET APK"] === apkFilter : true;
    const kondisiMatch = kondisiFilter ? row["KONDISI"] === kondisiFilter : true;
    return (id.includes(term) || name.includes(term)) && ulpMatch && apkMatch && kondisiMatch;
  });

  const getRekapStatusBaca = () => {
    let sudah = 0;
    let belum = 0;
    filteredRows.forEach((row) => {
      const status = row["KET APK"]?.toLowerCase();
      if (status === "sudah dibaca") sudah++;
      else belum++;
    });
    return { sudah, belum };
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data Pelanggan");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "data_pelanggan_filtered.xlsx");
  };

  // 🔧 Fungsi download semua foto hasil filter
  const downloadFilteredFotos = async () => {
    if (filteredRows.length === 0) {
      alert("Tidak ada data untuk diunduh!");
      return;
    }

    const zip = new JSZip();
    const folder = zip.folder("foto_meteran");

    for (const row of filteredRows) {
      const fileName = row["FILE FOTO"];
      if (fileName) {
        try {
          const response = await fetch(`/images/${fileName}`);
          const blob = await response.blob();
          folder.file(fileName, blob);
        } catch (err) {
          console.error("Gagal ambil foto:", fileName, err);
        }
      }
    }

    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, "foto_meteran.zip");
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      <h2 style={{ fontWeight: "bold", fontSize: "24px", marginBottom: "20px" }}>
        🔍 Monitoring Data Pelanggan Kode ACMT
      </h2>

      {/* Filter */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Cari ID Pelanggan atau Nama..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ padding: "8px", flex: "1 1 250px", border: "1px solid #ccc", borderRadius: "4px" }}
        />
        <select value={ulpFilter} onChange={(e) => setUlpFilter(e.target.value)} style={{ padding: "8px", flex: "1 1 150px" }}>
          <option value="">Semua ULP</option>
          {getUniqueValues("ULP").map((ulp) => (
            <option key={ulp} value={ulp}>{ulp}</option>
          ))}
        </select>
        <select value={apkFilter} onChange={(e) => setApkFilter(e.target.value)} style={{ padding: "8px", flex: "1 1 150px" }}>
          <option value="">Semua Ket APK</option>
          {getUniqueValues("KET APK").map((apk) => (
            <option key={apk} value={apk}>{apk}</option>
          ))}
        </select>
        <select value={kondisiFilter} onChange={(e) => setKondisiFilter(e.target.value)} style={{ padding: "8px", flex: "1 1 150px" }}>
          <option value="">Semua Kondisi</option>
          {getUniqueValues("KONDISI").map((kondisi) => (
            <option key={kondisi} value={kondisi}>{kondisi}</option>
          ))}
        </select>
        <button
          onClick={() => { setSearchTerm(""); setUlpFilter(""); setApkFilter(""); setKondisiFilter(""); }}
          style={{ padding: "8px 12px", backgroundColor: "#f44336", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" }}
        >
          Reset
        </button>
      </div>

      {/* Rekap */}
      <p style={{ marginBottom: "10px", fontWeight: "bold" }}>
        Jumlah Pelanggan: {filteredRows.length.toLocaleString()}
      </p>
      <div style={{ marginBottom: "15px" }}>
        <strong>Rekap Status Baca:</strong>
        <ul style={{ marginTop: "5px", paddingLeft: "20px" }}>
          <li>✅ Sudah Dibaca: {getRekapStatusBaca().sudah.toLocaleString()} pelanggan</li>
          <li>⏳ Belum Dibaca: {getRekapStatusBaca().belum.toLocaleString()} pelanggan</li>
        </ul>
      </div>

      {/* Tombol */}
      <div style={{ marginBottom: "15px" }}>
        <button onClick={fetchData} style={{ padding: "8px 12px", backgroundColor: "#2196f3", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", marginRight: "10px" }}>
          🔄 Refresh Data
        </button>
        <button onClick={exportToExcel} style={{ padding: "8px 12px", backgroundColor: "#4caf50", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer", marginRight: "10px" }}>
          📤 Export ke Excel
        </button>
        <button
          onClick={downloadFilteredFotos}
          style={{
            padding: "8px 12px",
            backgroundColor: "#ff9800",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >

          ⬇️ Download Foto
        </button>
      </div>

      {/* Tabel */}
      {rows.length === 0 ? (
        <p style={{ color: "red" }}>⚠️ Gagal memuat data. Klik Refresh Data.</p>
      ) : (
        <table
          cellPadding="8"
          style={{
            borderCollapse: "collapse",
            minWidth: "1000px",
            width: "100%",
            textAlign: "left",
            border: "2px solid #ccc",
            boxShadow: "0 0 8px rgba(0,0,0,0.1)"
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  backgroundColor: "#f0f0f0",
                  fontWeight: "bold",
                  border: "1px solid #ccc",
                  textAlign: "center"
                }}
              >
                AKSI
              </th>
              {Object.keys(rows[0]).map((key) => (
                <th
                  key={key}
                  style={{
                    backgroundColor: "#f0f0f0",
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                    border: "1px solid #ccc",
                    textAlign: "center"
                  }}
                >
                  {key}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredRows.map((row, i) => (
              <tr key={i}>
                <td style={{ textAlign: "center", border: "1px solid #ccc" }}>
                  <button
                    onClick={() => {
                      setFotoFile(row["FILE FOTO"]);
                      setShowModal(true);
                    }}
                    style={{ padding: "4px 8px", fontSize: "12px" }}
                  >
                    Lihat Foto
                  </button>
                </td>
                {Object.entries(row).map(([key, cell], j) => (
                  <td
                    key={j}
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      border: "1px solid #ccc"
                    }}
                  >
                    {key.trim().toUpperCase() === "LOKASI" && row["KORDINAT"] ? (
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${row["KORDINAT"]}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#2196f3", textDecoration: "underline" }}
                      >
                        Lihat Peta
                      </a>
                    ) : (
                      cell
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Preview kecil */}
      {fotoFile && !showModal && filteredRows.some((r) => r["FILE FOTO"] === fotoFile) && (
        <div style={{ marginTop: "20px" }}>
          <p style={{ fontWeight: "bold" }}>Foto Meteran: {fotoFile}</p>
          <img
            src={`/images/${fotoFile}`}
            alt={`Foto meteran ${fotoFile}`}
            style={{
              maxWidth: "300px",
              border: "1px solid #ccc",
              padding: "4px",
              cursor: "pointer"
            }}
            onClick={() => setShowModal(true)}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/not-found.jpg";
            }}
          />
        </div>
      )}

      {/* Modal zoom */}
      {showModal && fotoFile && (
        <div
          onClick={() => setShowModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
          }}
        >
          <img
            src={`/images/${fotoFile}`}
            alt={`Foto meteran ${fotoFile}`}
            style={{
              maxWidth: "70%",
              maxHeight: "70%",
              border: "4px solid #fff",
              borderRadius: "8px"
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/images/not-found.jpg";
            }}
          />
        </div>
      )}
    </div>
  );
}

export default Monitoring;
